module.exports = __webpack_public_path__ + "bc60e380390cb4f2e2e7a3baffd6ecdf.svg";